export * from '@primeuix/themes/material/accordion';
export { default } from '@primeuix/themes/material/accordion';
